import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { NutritionOmega3DiagramContent } from "./NutritionOmega3Diagram";
import { NutritionOmega3KeyContent } from "./NutritionOmega3Key";

const SvgNutritionOmega3DiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1240, 1490)}
      viewBox={diagramOnly ? "0 176 1024 1240" : "0 0 1024 1490"}
    >
      <g id="nutrition-omega3-diagram+key" clipPath="url(#clip0_18284_196607)">
        <rect width={1024} height={diagramOnly ? 1240 : 1490} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <NutritionOmega3KeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <NutritionOmega3DiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18284_196607">
          <rect width={1024} height={1490} fill="white" />
        </clipPath>
        <clipPath id="clip1_18284_196607">
          <rect width={1024} height={1240} fill="white" transform="translate(0 176)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgNutritionOmega3DiagramKey;
